import { apiClient } from '@shared/api';
import type { ApiResponse } from '@shared/types';
import type { ApkDownloadInfoDto } from '../types';

class DownloadService {
  async getDownloadInfo(): Promise<ApkDownloadInfoDto> {
    const { data } = await apiClient.get<ApiResponse<ApkDownloadInfoDto>>(
      '/app/downloads/info',
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to fetch download info');
  }

  async downloadApk(variant: string): Promise<{ blob: Blob; fileName: string }> {
    const response = await apiClient.get(`/app/downloads/${variant}`, {
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'] ?? '';
    const match = disposition.match(/filename="?([^";\s]+)"?/);
    const fileName = match?.[1] ?? `csc_dop_${variant}.apk`;
    return { blob: response.data as Blob, fileName };
  }
}

export const downloadService = new DownloadService();
